import axios from 'axios';
import { BASE_URL } from '../../../constants/api';

export interface ElevenDbCandidate {
  id: number;
  name?: string;
  title?: string;
  birth_date?: string;
  poster?: string;
  gender?: string;
  year?: number;
  type?: string;
  known_for?: string;
  tmdb_id?: number;
  imdb_id?: string;
}

export interface ElevenDbSearchResult {
  status: number;
  results: ElevenDbCandidate[];
  total_count: number;
}

export interface ElevenDbLinkResponse {
  id: number;
  eleven_db_person_id?: number | null;
  eleven_db_title_id?: number | null;
}

class ElevenDbApiService {
  private baseUrl = `${BASE_URL}/api/v1/eleven-db`;

  async searchCastCandidates(castId: number, query?: string): Promise<ElevenDbSearchResult> {
    const params: Record<string, string> = {};
    if (query) params.q = query;
    const response = await axios.get(`${this.baseUrl}/cast/${castId}/candidates/`, { params });
    return response.data;
  }

  async linkCast(castId: number, elevenDbPersonId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/cast/${castId}/link/`, {
      eleven_db_person_id: elevenDbPersonId,
    });
    return response.data;
  }

  async unlinkCast(castId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/cast/${castId}/unlink/`, {});
    return response.data;
  }

  async searchSeriesCandidates(
    seriesId: number,
    query?: string,
    type: string = 'tv'
  ): Promise<ElevenDbSearchResult> {
    const params: Record<string, string> = {};
    if (query) params.q = query;
    params.type = type;
    const response = await axios.get(`${this.baseUrl}/series/${seriesId}/candidates/`, { params });
    return response.data;
  }

  async linkSeries(seriesId: number, elevenDbTitleId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/series/${seriesId}/link/`, {
      eleven_db_title_id: elevenDbTitleId,
    });
    return response.data;
  }

  async unlinkSeries(seriesId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/series/${seriesId}/unlink/`, {});
    return response.data;
  }

  async searchContentCandidates(
    contentId: number,
    query?: string,
    type: string = 'movie'
  ): Promise<ElevenDbSearchResult> {
    const params: Record<string, string> = {};
    if (query) params.q = query;
    params.type = type;
    const response = await axios.get(`${this.baseUrl}/content/${contentId}/candidates/`, {
      params,
    });
    return response.data;
  }

  async linkContent(contentId: number, elevenDbTitleId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/content/${contentId}/link/`, {
      eleven_db_title_id: elevenDbTitleId,
    });
    return response.data;
  }

  async unlinkContent(contentId: number): Promise<ElevenDbLinkResponse> {
    const response = await axios.post(`${this.baseUrl}/content/${contentId}/unlink/`, {});
    return response.data;
  }
}

export const elevenDbApiService = new ElevenDbApiService();
